// extracted by mini-css-extract-plugin
module.exports = {"KeenSliderWrapper":"Slider_KeenSliderWrapper__PbLhc"};